import React, { Fragment } from "react";
import Script from "react-load-script";
import ottawa from "../../../../semantic/dist/themes/fibrestream/assets/images/ottawa-mobile.png";

class Ottawa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      indexLoaded: false,
      mounted: false
    };
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  handleScriptLoad() {
    this.setState({
      indexLoaded: true
    });
  }

  animationLoaded() {
    window.init();
  }

  componentWillUnmount() {
    window.destroyFibrestreamCanvas && window.destroyFibrestreamCanvas();
  }

  render() {
    const { isTouchDevice } = this.props;
    const { indexLoaded, mounted } = this.state;

    return (
      <Fragment>
        <div className="ui container xs-mx-0">
          <div className="screen-responsive">
            <div className="screen-ui">
              {
                isTouchDevice ? <img src={ottawa} alt="Ottawa" style={{ width: "100%" }} />
                  :
                  <div id="animation_container" style={{ width: "100%" }}>
                    <canvas
                      id="canvas"
                      width="100%"
                      style={{
                        position: "absolute",
                        display: "block",
                        backgroundColor: "transparent"
                      }}
                    />
                    <div
                      id="dom_overlay_container"
                      style={{
                        pointerEvents: "none",
                        overflow: "hidden",
                        width: "100%",
                        position: "absolute",
                        left: "0px",
                        top: "0px",
                        display: "block"
                      }}
                    />
                  </div>
              }
            </div>
          </div>
        </div>
        {
          !isTouchDevice && <Fragment>
            {mounted && (
              <Script
                url={`${process.env.PUBLIC_URL}/assets/js/ottawa/index.js`}
                onLoad={this.handleScriptLoad.bind(this)}
              />
            )}
            {indexLoaded && (
              <Script
                url={`${process.env.PUBLIC_URL}/assets/js/ottawa/fs-animation.js`}
                onLoad={this.animationLoaded.bind(this)}
              />
            )}
          </Fragment>
        }
      </Fragment>
    );
  }
}

export default Ottawa;



// WEBPACK FOOTER //
// ./src/components/home/hero/sketch/Ottawa.js